import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Switch,
  Typography,
} from '@mui/material';
import React from 'react';

interface ModalCloseThemesProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  checked: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isSubmitting: boolean;
}

export const ModalCloseThemes = ({
  open,
  onClose,
  onCancel,
  onConfirm,
  checked,
  handleChange,
  isSubmitting,
}: ModalCloseThemesProps) => {
  return (
    <Dialog
      open={open}
      PaperProps={{ style: { padding: '20px' } }}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '33.75rem',
            display: 'flex',
            padding: '20px ',
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          color: '#000000',
          fontWeight: '500',
          fontSize: '20px',
          padding: '0',
          marginBottom: '20px',
        }}
      >
        Fechar pautas
      </DialogTitle>
      <DialogContent sx={{ padding: '0' }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            fontWeight: '500',
            fontSize: '16px',
            color: 'rgba(0, 0, 0, 0.54)',
            padding: '0',
          }}
        >
          Deseja realmente fechar as pautas?
        </DialogContentText>
        <Box display="flex" alignItems="center">
          <Switch
            checked={checked}
            onChange={handleChange}
            sx={{ marginTop: '10px' }}
          />
          <Typography mt="10px">Notificar participantes por e-mail</Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '0', marginTop: '10px' }}>
        <Button
          onClick={onCancel}
          sx={{ color: '#9E9E9E', padding: '6px 8px' }}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          autoFocus
          variant="contained"
          disabled={isSubmitting}
          endIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          color="success"
          sx={{
            color: '#FFFFFF',
            fontWeight: '500',
            fontSize: '15px',
            padding: '6px 22px',
          }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
